module.exports = __webpack_public_path__ + "c20b39d42d46093a6965b1220f438154.pdf";